<h2 class="mat-subheading-2 full-width fill">{{title}}</h2>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onDismiss()">No</button>
  <button mat-raised-button color="accent" (click)="onConfirm()">Sí</button>
</div>